/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React from "react";

import Card from "src/components/cards/Card.react";

/**
 * The LoadingCard component
 *
 * @author Thais Watanabe
 */
const LoadingCard = () => {
  return (
    <Card>
      <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="max-w-none mx-auto">
          <div className="bg-white overflow-hidden sm:rounded-lg">
            <div className="loader"></div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default LoadingCard;
